<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-md-12 m-0 p-0" :class="['bg-white', extraButtons]" >
      <b-breadcrumb class="pl-2 col-page-header" style="padding:0%">
        <b-breadcrumb-item
          v-for="(link, key) in items"
          :key="`bread-${key}`"
          :to="link"
          class="pl-0"
        >
          <b-icon
            v-if="link.text === '/'"
            icon="house-fill"
            scale="1.25"
            shift-v="1.25"
            aria-hidden="true"
            class="mr-1"
          ></b-icon>
          {{ link.text }}
        </b-breadcrumb-item>
      </b-breadcrumb>
      <!-- <div class="page-title-box ml-1 mt-4" v-if="title">
        <div class="page-title m-0 ml-1 mb-1"
          >{{ title }} <small v-if="subtitle"> {{ subtitle }} </small>
          <div class="other-actions mr-3  mt-0 float-right" v-if="(extraButtons.length > 0)">
            <b-button
              v-for="(button, key) in extraButtons"
              :key="key"
              size="sm"
              class="p-0 ml-2 "
              variant="link"
              v-b-tooltip.hover="{
                variant: button.variant,
                placement: 'bottom',
                title: button.title,
              }"
              :to="!('function' in button)?button.to:''"
              @click="('function' in button)?emitClick():{}"

            >
              <label class="b-label-plus">{{
                'label' in button ? button.label : ''
              }}</label>
              <b-icon
                class="b-icon-plus"
                :icon="button.icon"
                :variant="button.variant.scss"
                scale="1.4"
              ></b-icon>
            </b-button>
            <slot name="button"> </slot>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <!-- end page title -->
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    extraButtons: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  methods: {
    emitClick(){
      this.$emit('clickModal', true)
    }
  },
}
</script>

<style lang="scss">
.b-icon-plus {
  margin-left: 10px;
}
.b-label-plus {
  font-weight: normal !important;
}
</style>
